/**
 * theme.ts
 *
 * Gerencia o tema dark/light do Fin-X.
 *
 * Prioridade:
 *   1. Preferência manual do usuário (salva em localStorage)
 *   2. Preferência do sistema operacional (prefers-color-scheme)
 *
 * Uso:
 *   import { initTheme, toggleTheme, isDarkTheme } from '@/utils/theme'
 *   initTheme()      // chamar uma vez no mounted() do App.vue
 *   toggleTheme()    // alterna e persiste a escolha
 *   isDarkTheme()    // retorna true se o tema escuro está ativo
 */

const DARK_CLASS = 'dark-theme'
const STORAGE_KEY = 'finx-theme'

function applyTheme(dark: boolean): void {
  document.documentElement.classList.toggle(DARK_CLASS, dark)
}

/** Retorna true se o tema escuro está ativo no momento. */
export function isDarkTheme(): boolean {
  return document.documentElement.classList.contains(DARK_CLASS)
}

/** Alterna entre dark e light, persistindo a escolha no localStorage. */
export function toggleTheme(): void {
  const newDark = !isDarkTheme()
  applyTheme(newDark)
  localStorage.setItem(STORAGE_KEY, newDark ? 'dark' : 'light')
}

/**
 * Inicializa o tema: usa a preferência salva pelo usuário se existir,
 * caso contrário usa tema claro (padrão).
 */
export function initTheme(): void {
  const stored = localStorage.getItem(STORAGE_KEY)
  applyTheme(stored === 'dark')
}
